import swal from 'sweetalert';
import I18n from 'i18n-js';
import 'javascripts/i18n/translations';
import $ from "jquery";

$(document).on('turbolinks:load', function () {
    let timerKey;
    let searchRequestByKey;
    let delay = 1000;
    let $userKey = $('input#user_key');
    let $userFirstName = $('input#user_first_name');
    let $imgUser = $('#img-user');
    let $nameUser = $('#name-user').find('h4');
    let $imgUserLoading = $('#img-user-loading');
    let $nameUserLoading = $('#name-user-loading');
    let $submitButton = $('#m_login_signin_submit');

    let changesByUserType = () => {
        const labels = {
            'student': I18n.t('messages.user_types.matricula'),
            'employee': I18n.t('messages.user_types.empleado'),
            'external': '',
            'diplomat': I18n.t('messages.user_types.diplomado')
        };

        let userTypeVal = $("input[name='user[user_type]']:checked").val();
        let $userName = $('input#user_first_name');
        let folioUser = $('#user-folio').find('h6');

        resetSearchByKey();
        $userKey.attr('placeholder', labels[userTypeVal]);
        folioUser.text("");
        $userName.val('');
        $submitButton.attr('disabled', 'disabled');
        if (userTypeVal === 'external') {
            $userName.removeClass('m--hide');
            $userKey.addClass('m--hide');
            $userKey.val('');
        } else {
            $userName.addClass('m--hide');
            $userKey.removeClass('m--hide');
            let key = $userKey.val();
            let userType = $('input[name="user[user_type]"]:checked').val();
            resquestNameAndPhoto(key, userType);
        }
    };

    let resetSearchByKey = () => {
        $('#img-user').addClass('m--hide').attr('src', '');
        $('#name-user').find('h4').addClass('m--hide').text('');
        $imgUserLoading.addClass('m--hide');
        $nameUserLoading.addClass('m--hide');
        searchRequestByKey && searchRequestByKey.abort();
    };

    let resquestNameAndPhoto = (key, userType) => {
        if (key.length > 0) {
            userType === 'student' && $imgUserLoading.removeClass('m--hide');
            $nameUserLoading.removeClass('m--hide');
            $submitButton.attr('disabled', 'disabled');
            searchRequestByKey = $.ajax({
                url: `/api/v1/sessions/search_name/${key}?user_type=${userType}`,
                method: 'GET',
                success: (data) => {
                    if (data.photo !== null) {
                        $imgUser.removeClass('m--hide');
                        $imgUser.attr('src', `data:image/jpeg;base64,${data.photo}`);
                    }
                    if (data.name !== null) {
                        $nameUser.removeClass('m--hide');
                        $nameUser.text(data.name);
                        $userFirstName.val(data.name);
                        $submitButton.removeAttr('disabled');
                    }
                },
                error: (error) => {
                    let response = error.responseJSON;
                    $imgUser.addClass('m--hide');
                    $imgUser.attr('src', '');
                    $userFirstName.val('');
                    $submitButton.attr('disabled', 'disabled');
                    if (error.status === 422) {
                        $nameUser.removeClass('m--hide');
                        $nameUser.text(response.message);
                    }
                },
                complete: () => {
                    $imgUserLoading.addClass('m--hide');
                    $nameUserLoading.addClass('m--hide');
                }
            });
        } else {
            $imgUserLoading.addClass('m--hide');
            $nameUserLoading.addClass('m--hide');
        }
    };

    let userKey = document.getElementById('user_key');
    if (userKey !== null) {
        userKey.addEventListener('input', function () {
            let key = $(this).val();
            let userType = $('input[name="user[user_type]"]:checked').val();

            $imgUser.addClass('m--hide').attr('src', '');
            $nameUser.addClass('m--hide').text('');
            $nameUserLoading.removeClass('m--hide');
            $submitButton.attr('disabled', 'disabled');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestNameAndPhoto(key, userType);
            }, delay);
        });
    }

    if (userKey !== null) {
        let key = $userKey.val();
        let userType = $('input[name="user[user_type]"]:checked').val();
        resquestNameAndPhoto(key, userType);
    }

    let userFolio = document.getElementById('user_folio');
    if (userFolio !== null) {
        userFolio.addEventListener('input', function () {
            let accessKey = $('.row#user-access-key').find('h6');
            $('input#user_access_key').val('');
            accessKey.add('m--hide').html('');
        });
    }

    let userName = document.getElementById('user_first_name');
    if (userName !== null) {
        userName.addEventListener('input', function () {
            let userNameVal = $(this).val().trim();
            if (userNameVal === '') {
                $submitButton.attr('disabled', 'disabled');
            } else {
                $submitButton.removeAttr('disabled');
            }
        });
    }

    if (userKey !== null) {
        changesByUserType();
    }
    $('.form-check-label input.login').click(() => { changesByUserType() });

    $('#access_password_exam').on('click', () => {
        swal({
            title: I18n.t('messages.access_password'),
            text: I18n.t('messages.exam_access_password'),
            content: {
                element: "input",
                attributes: {
                    type: "password",
                },
            },
            buttons: {
                confirm: I18n.t('messages.accept'),
                cancel: {
                    text: I18n.t('messages.cancel'),
                    visible: true,
                    closeModal: true,
                }
            }
        }).then(function(result) {
            if (result !== null) {
                let accessKey = $('.row#user-access-key').find('h6');

                $('input#user_access_key').val(result);
                $('input#user_folio').val('');
                accessKey.removeClass('m--hide').html(`Clave de acceso: ${result}`);
            } else {

            }
        })
    });

    /*
    let userFolio = document.getElementById('user_folio');
    if (userFolio != null) {
        userFolio.addEventListener('input', function(event) {
            let folio = $(this).val();
            let userKey = $('input#user_key').val();
            let userType = $('input[name="user[user_type]"]:checked').val();
            let folioUser = $('#user-folio').find('h6');
            let userNameInput = $('input#user_first_name');
            folioUser.text("");

            window.clearTimeout(timerFolio);
            searchRequestByFolio && searchRequestByFolio.abort();
            timerFolio = window.setTimeout(function(){
                if (folio.length > 0) {
                    searchRequestByFolio = $.ajax({
                        url: `/api/v1/sessions/validate_folio/${folio}?user_type=${userType}&key=${userKey}`,
                        method: 'GET',
                        success: (data) => {
                            if (data.message !== null) {
                            }
                        },
                        error: (error) => {
                            let response = error.responseJSON;
                            folioUser.addClass('m--hide');
                            if (error.status === 422) {
                                folioUser.removeClass('m--hide');
                                folioUser.text(response.message);
                            }
                        }
                    });
                } else {
                    folioUser.addClass('m--hide');
                }
            }, delay);
        });
    }
    */
});
